<template>
  <svg data-v-53726859="" xmlns="http://www.w3.org/2000/svg" width="222.318" height="47.785" viewBox="0 0 222.318 47.785">
    <title data-v-53726859="">{{ $t('views.map.logos.wildfireSafe') }}</title>
    <g id="Group_1057" data-v-53726859="" data-name="Group 1057" transform="translate(-124 -75)">
      <g id="Group_817" data-v-53726859="" data-name="Group 817" transform="translate(124 75)">
        <g id="Group_81596" data-v-53726859="" data-name="Group 81596">
          <path
            id="Path_773199"
            data-v-53726859=""
            data-name="Path 773199"
            d="M48.282,110.3a19.8,19.8,0,0,1-1.828-2.336,21.807,21.807,0,0,1-1.422-2.437h0l-.3-.609c-.068-.135-.135-.271-.2-.44-.034-.034-.034-.1-.068-.135-.1-.2-.169-.44-.271-.643-.034-.1-.1-.237-.135-.339-.068-.2-.135-.406-.2-.576a2.537,2.537,0,0,1-.169-.542,22.429,22.429,0,0,1-1.016-6.6A22.114,22.114,0,0,1,63.855,73.534c-.3,0-.609-.034-.914-.034A22.149,22.149,0,0,0,40.8,95.641a21.213,21.213,0,0,0,1.016,6.6c.068.169.1.339.169.542s.135.406.2.576c.034.1.1.237.135.339.1.2.169.44.271.643.034.034.034.1.068.135.068.135.135.271.2.44l.3.609h0q.66,1.27,1.422,2.438A19.8,19.8,0,0,0,46.42,110.3a22.055,22.055,0,0,0,16.555,7.448,8.247,8.247,0,0,0,.914-.034A22.172,22.172,0,0,1,48.282,110.3Z"
            transform="translate(-40.8 -73.5)"
            :fill="themeColor"></path>
          <path
            id="Path_774198"
            data-v-53726859=""
            data-name="Path 774198"
            d="M99.571,105.914a26.366,26.366,0,0,1-.406,3.284,24.271,24.271,0,0,1-.812,3.081h0a6.106,6.106,0,0,1-.271.711,4.108,4.108,0,0,0-.169.474c-.034.068-.034.1-.068.169l-.3.711c-.068.135-.1.237-.169.372-.1.2-.2.44-.3.643s-.169.372-.271.576a25.15,25.15,0,0,1-4.435,6.026,24.77,24.77,0,0,1-34.26.711c.237.237.474.508.711.745a24.724,24.724,0,0,0,35.005,0,25.151,25.151,0,0,0,4.435-6.026,3,3,0,0,0,.271-.576c.1-.2.2-.406.3-.643.068-.135.1-.237.169-.372l.3-.711c.034-.068.034-.1.068-.169a2.654,2.654,0,0,0,.169-.474c.1-.237.169-.474.271-.711h0a24.265,24.265,0,0,0,.812-3.081,27.18,27.18,0,0,0,.406-3.284,24.608,24.608,0,0,0-7.211-18.958c-.237-.237-.508-.474-.745-.711A24.727,24.727,0,0,1,99.571,105.914Z"
            transform="translate(-52.243 -82.893)"
            :fill="themeColor"></path>
          <path
            id="Path_775197"
            data-v-53726859=""
            data-name="Path 775197"
            d="M60.658,117.384a12.669,12.669,0,0,1-2.336-16.115c.779-1.32,1.727-2.471,2.607-3.724,3.047-3.893,3.385-4.773,3.521-9.648,2.438,2.708,2.607,5.857,2.573,9.107,4.6-3.792,3.893-11.477-1.49-17.6a20.884,20.884,0,0,0-4.469,38.289A1.279,1.279,0,0,1,60.658,117.384Z"
            transform="translate(-47.15 -77.403)"
            fill="#58bdec"></path>
          <path
            id="Path_776196"
            data-v-53726859=""
            data-name="Path 776196"
            d="M104.393,77.1a21.082,21.082,0,0,0-3.893.372c8.057,2.336,18.315,15.505,14.117,27.693,3.284-2.031,3.859-5.383,4.029-9.344,2.3,3.893,3.047,7.617,2.1,11.612a18.473,18.473,0,0,1-3.182,6.839A20.917,20.917,0,0,0,104.393,77.1Z"
            transform="translate(-80.289 -75.881)"
            fill="#f0b26c"></path>
          <path
            id="Path_777195"
            data-v-53726859=""
            data-name="Path 777195"
            d="M104.751,160.368a16.609,16.609,0,0,0-1.32-1.828c-1.49-1.964-1.625-2.37-1.727-4.773-1.185,1.32-1.253,2.878-1.253,4.469-2.37-1.964-1.862-5.992,1.083-9.141-4.029-.169-10.495,7.143-8.227,13.846-1.625-.948-1.964-2.607-2-4.57a7.125,7.125,0,0,0-1.016,5.755,5.079,5.079,0,0,0,.372,1.219,20.921,20.921,0,0,0,6.2,1.151c-3.284-7.583-.339-11.646-.339-11.646-2.031,3.656.542,9.174,1.9,11.612a21.124,21.124,0,0,0,7.177-1.591A6.624,6.624,0,0,0,104.751,160.368Z"
            transform="translate(-73.402 -123.501)"
            fill="#62b57d"></path>
        </g>
      </g>
      <g id="Group_816199" data-v-53726859="" data-name="Group 816199" transform="translate(180.909 90.806)">
        <path
          id="Path_778194"
          data-v-53726859=""
          data-name="Path 778194"
          d="M224.67,140.922l3.347-12.322h2.231l-4.412,15.567h-2.231l-4.057-12.626-4.006,12.626h-2.13L208.9,128.6h2.231l3.448,12.17,3.9-12.17h2.282Z"
          transform="translate(-208.9 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_779193"
          data-v-53726859=""
          data-name="Path 779193"
          d="M259.88,144.167H257.7V128.6h2.18Z"
          transform="translate(-232.955 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_780192"
          data-v-53726859=""
          data-name="Path 780192"
          d="M281.482,144.167H272V128.6h2.13v13.539h7.353Z"
          transform="translate(-240.003 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_781191"
          data-v-53726859=""
          data-name="Path 781191"
          d="M303.226,144.167H297.8V128.6h5.426a7.35,7.35,0,0,1,5.274,2.079,7.612,7.612,0,0,1,2.13,5.73,7.494,7.494,0,0,1-2.13,5.679A7.146,7.146,0,0,1,303.226,144.167Zm-3.245-1.876h3.195a5.16,5.16,0,0,0,3.8-1.521,5.8,5.8,0,0,0,1.521-4.31,6.126,6.126,0,0,0-1.47-4.361,4.967,4.967,0,0,0-3.752-1.521h-3.245v11.713Z"
          transform="translate(-252.721 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_782190"
          data-v-53726859=""
          data-name="Path 782190"
          d="M333.33,144.167H331.2V128.6h9.482v1.978h-7.3v5.02h6.643v2.028H333.38v6.541Z"
          transform="translate(-269.184 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_783189"
          data-v-53726859=""
          data-name="Path 783189"
          d="M359.38,144.167H357.2V128.6h2.18Z"
          transform="translate(-282 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_784188"
          data-v-53726859=""
          data-name="Path 784188"
          d="M379.563,144.167l-3.55-6.389H373.68v6.389H371.5V128.6h5.882a4.7,4.7,0,0,1,3.448,1.318,4.511,4.511,0,0,1,1.318,3.3,4.462,4.462,0,0,1-1.014,2.89,4.34,4.34,0,0,1-2.789,1.521l3.7,6.541ZM373.68,135.9h3.3a3.267,3.267,0,0,0,2.13-.71,2.354,2.354,0,0,0,.811-1.927,2.529,2.529,0,0,0-.811-1.978,3.044,3.044,0,0,0-2.13-.761h-3.3Z"
          transform="translate(-289.049 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_785187"
          data-v-53726859=""
          data-name="Path 785187"
          d="M409.882,144.167H400.4V128.6h9.482v1.978h-7.3v4.767h6.643v2.028H402.58v4.767h7.3Z"
          transform="translate(-303.295 -128.296)"
          :fill="themeColor"></path>
        <path
          id="Path_786186"
          data-v-53726859=""
          data-name="Path 786186"
          d="M436.866,132.158l-3.093.862a2.137,2.137,0,0,0-.71-1.318,2.53,2.53,0,0,0-1.876-.608,2.21,2.21,0,0,0-1.521.507,1.421,1.421,0,0,0-.608,1.166c0,.811.507,1.318,1.521,1.471l2.079.406A5.854,5.854,0,0,1,436,136.316a4.442,4.442,0,0,1,1.166,2.992,4.572,4.572,0,0,1-1.572,3.448,5.989,5.989,0,0,1-4.209,1.471,6.361,6.361,0,0,1-4.564-1.521A5.649,5.649,0,0,1,425,139.257l3.195-.761a2.78,2.78,0,0,0,.913,1.927,3.313,3.313,0,0,0,2.333.761,2.674,2.674,0,0,0,1.623-.456,1.421,1.421,0,0,0,.609-1.166,1.351,1.351,0,0,0-.456-1.014,2.265,2.265,0,0,0-1.217-.558l-2.13-.406a5.236,5.236,0,0,1-3.093-1.623,4.18,4.18,0,0,1-1.116-2.941,4.7,4.7,0,0,1,1.623-3.6,5.745,5.745,0,0,1,3.955-1.42,7.734,7.734,0,0,1,2.485.406,4.705,4.705,0,0,1,1.724,1.014,6.111,6.111,0,0,1,1.014,1.318A11.591,11.591,0,0,1,436.866,132.158Z"
          transform="translate(-315.421 -128)"
          fill="#58bdec"></path>
        <path
          id="Path_787185"
          data-v-53726859=""
          data-name="Path 787185"
          d="M463.916,144.167l-1.116-3.144h-6.034l-1.116,3.144H452l5.882-15.567h4.006l5.781,15.567ZM459.86,132.5l-1.927,5.375h3.752Z"
          transform="translate(-328.73 -128.296)"
          fill="#58bdec"></path>
        <path
          id="Path_788184"
          data-v-53726859=""
          data-name="Path 788184"
          d="M492.4,144.167h-3.5V128.6h10.04v3.3H492.4v3.3h5.781v3.144h-5.73v5.831Z"
          transform="translate(-346.918 -128.296)"
          fill="#58bdec"></path>
        <path
          id="Path_789183"
          data-v-53726859=""
          data-name="Path 789183"
          d="M525.488,144.167H515.6V128.6h9.837v3.3h-6.389v2.941h5.781v3.042h-5.781v2.992h6.389v3.3Z"
          transform="translate(-360.079 -128.296)"
          fill="#58bdec"></path>
      </g>
    </g>
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { storeToRefs } from 'pinia'

import settingsStore from '@/stores/settingsStore.ts'

const { theme } = storeToRefs(settingsStore())

const themeColor = computed(() => (theme.value === 'light' ? '#000000' : '#f8f8f8'))
</script>
